import { useState } from 'react';
import { Variable } from '../../../model/interfaces/variable';
import { VariableListItem } from './variableListItem';

interface VariableListProps {
  variables?: Variable[];
  saveVariable: (variable: Variable) => void;
  deleteVariable: (variable: Variable) => void;
}

/**
 * @param props The list of variables and the save and delete function
 * @returns A list of accordions
 */
export const VariablesList = (props: VariableListProps) => {
  const { variables, saveVariable, deleteVariable } = props;
  const [currentlyOpenAccordion, setCurrentlyOpenAccordion] = useState<string | false>(false);
  const onToggleAccordion = (accordionId: string, isOpen: boolean) => {
    isOpen = !isOpen;
    setCurrentlyOpenAccordion(isOpen ? accordionId : '');
  };

  return (
    <>
      {variables?.map((variable, key = variable.variableId) => (
        <VariableListItem
          variable={variable}
          key={key}
          saveVariable={saveVariable}
          deleteVariable={deleteVariable}
          isOpen={currentlyOpenAccordion === variable.variableId.toString()}
          onToggle={onToggleAccordion}
        />
      ))}
    </>
  );
};
